import { api } from '../../apiAxios';
import { urlHttpGov } from '../../urls';
import { getToken } from '../../LStorage/token';

class VotacoesService {
    private baseURL: string = `${urlHttpGov}/backend/app/entidade`;

    async getVotacoes(idEntidade: string | number, signal: AbortSignal): Promise<any> {

        let { data } = await api.get(`${this.baseURL}/${idEntidade}/votacao`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async postVotacoes(
        idEntidade: string | number,
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.post(`${this.baseURL}/${idEntidade}/votacao`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async putVotacoes(
        idEntidade: string | number,
        idVotacao: any,
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.put(`${this.baseURL}/${idEntidade}/votacao/${idVotacao}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async deleteVotacoes(
        idEntidade: string | number,
        idVotacao: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.delete(`${this.baseURL}/${idEntidade}/votacao/${idVotacao}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async getResultados(
        idEntidade: string | number,
        idVotacao: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.get(`${this.baseURL}/${idEntidade}/votacao/${idVotacao}/resultados`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async getAlternativa(
        idEntidade: string | number,
        idVotacao: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.get(`${this.baseURL}/${idEntidade}/votacao/${idVotacao}/alternativa`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async postAlternativa(
        idEntidade: string | number,
        idVotacao: any,
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.post(`${this.baseURL}/${idEntidade}/votacao/${idVotacao}/alternativa`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data;
    }

    async putAlternativa(
        idEntidade: string | number,
        idVotacao: any,
        idAlternativa: any,
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.put(`${this.baseURL}/${idEntidade}/votacao/${idVotacao}/alternativa/${idAlternativa}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data;
    }

    async deleteAlternativa(
        idEntidade: string | number,
        idVotacao: any,
        idAlternativa: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.delete(`${this.baseURL}/${idEntidade}/votacao/${idVotacao}/alternativa/${idAlternativa}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async getCargo(signal: AbortSignal): Promise<any> {

        let { data } = await api.get(`${urlHttpGov}/backend/config/cargo`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new VotacoesService();
